import displayModel from "../../../../models/custom-vision/custom-vision.displays.model";
import languageModel from '../../../../models/language.model';
import { Dialog } from 'construct-ui';
import paginationComponent from '../../../../components/pagination/pagination.component';
import ViewBase from '../../../view-base.view';
import CVDisplayAddView from '../displays/custom-vision.displays-add.view';
import CVDisplayEditView from '../displays/custom-vision.displays-edit.view';

export default function CVTDisplaysListView() {
    ViewBase.call(this);

    let inputDataModel = { 
        searchQuery: "", 
        totalCount: 0, 
        pageIndex: 1, 
        pageSize: 10 
    };

    let listOfDisplays = [];

    let selectedProjectId = 0;
    let selectedDisplayId = 0;
    let isPopupAddDisplayOpened = false;
    let isPopupEditDisplayOpened = false;

    let getSearchQuery = (e) => {
        inputDataModel.searchQuery = e.target.value;
    }

    let _search = () => {
        inputDataModel.pageIndex = 1;
        _loadDisplays();
    }

    let _clearFilter = () => {
        inputDataModel.searchQuery = "";
        _loadDisplays();
    }

    let onPageSizeChanged = (pageIndex, pageSize) => {
        inputDataModel.pageIndex = pageIndex;
        inputDataModel.pageSize = pageSize;
        _loadDisplays();
    }

    let onPageChanged = (pageIndex) => {
        inputDataModel.pageIndex = pageIndex;
        _loadDisplays();
    }

    let _loadDisplays = () => {
        this.showLoading();

        displayModel.getDisplaysList(
            _displaysListSuccessCallBack,
            _displaysListErrorCallBack,
            selectedProjectId,
            inputDataModel.searchQuery, inputDataModel.pageIndex, inputDataModel.pageSize
        );
    }

    let _displaysListSuccessCallBack = (result) => {
        this.hideLoading();

        listOfDisplays = result.data;
        if (listOfDisplays == null) {
            listOfDisplays = [];
        }
        inputDataModel.totalCount = result.total;
        inputDataModel.pageIndex = result.pageIndex;
        inputDataModel.pageSize = result.pageSize;
    }

    let _displaysListErrorCallBack = (error) => {
        this.hideLoading();

        listOfDisplays = [];

        this.handleError(error);
    }

    function showEditDisplayPopup(displayId) {
        isPopupEditDisplayOpened = true;
        selectedDisplayId = displayId;
    }

    let showDeleteDisplayConfirmation = (displayId) => {
        this.showConfirm(this.getText("LT00000140XXX", "Are you sure you want to delete this display?"), this.getText("LT00000141XXX", "Delete Display"), (e) => {

            if (e == "YES") {
                displayModel.deactivateDisplay(
                    () => {
                        this.showMessage(this.getText("LT00000142XXX", "The display has been deleted."), this.getText("LT00000141XXX", "Delete Display"));

                        _loadDisplays();
                    }, (error) => {
                        if (error.code == 404) {
                            inputDataModel = { searchQuery: "", totalCount: 0, pageIndex: 1, pageSize: 10 };
                        }

                        this.handleError(error);
                    },
                    selectedProjectId,
                    displayId);
            }
        });

    }

    let onAddDisplayComplete = () => {
        isPopupAddDisplayOpened = false;
        _loadDisplays();
    }

    let onEditDisplayComplete = () => {
        isPopupEditDisplayOpened = false;
        _loadDisplays();
    }

    function _createNewDisplay() {
        isPopupAddDisplayOpened = true;
    }

    return {
        oninit: (vnode) => {
            if (vnode.attrs.projectId) {
                selectedProjectId = vnode.attrs.projectId;

                _loadDisplays();
            }
        },
        view: (vnode) => {
            return [
                m('.row',
                    m('.col-md-12',
                        m('.d-flex.justify-content-end.mb-2',
                            m('a.btn.btn-outline-primary.btn-search[data-bs-toggle="collapse"][href="#showSearchBarRc"][role="button"][aria-controls="showSearchBar"][aria-expanded="false"]',
                                m('span.search-arrow.me-2',
                                    m('i.bi.bi-search')
                                ), this.getText("LT00000001", "Search")
                            )
                        ),
                        m('.card mb-3.searchbox.collapse[id="showSearchBarRc"]',
                            m('.card-body.py-3',
                                m('.row',
                                    m('.container',
                                        m('.row',
                                            m('.col-md-6',
                                                m('label.form-label', this.getText("LT00000048XX", "Display Name")),
                                                m('input.form-control.form-control-bg', 
                                                    { 
                                                        type: 'text',
                                                        placeholder: this.getText("LT00000048XX", "Display Name"),
                                                        value: inputDataModel.searchQuery,
                                                        onchange: getSearchQuery 
                                                    }
                                                )
                                            ),
                                            m('.col-md-6.gap-2.d-sm-flex.mt-4',
                                                m('button.btn.btn-primary.px-4.gap-3', { onclick: _search }, this.getText("LT00000001", "Search")),
                                                m('button.btn.btn-white.px-4.gap-3', { onclick: _clearFilter }, this.getText("LT00000031", "Clear")),
                                            ),
                                        )
                                    )
                                )
                            )
                        ),
                        m('.card',
                            m('.card-body',
                                m('.d-flex.justify-content-end mb-2',
                                    m('button.btn.btn-outline-primary[type="button"]',  
                                        { onclick: _createNewDisplay }, [
                                            m("i.bi.bi-plus-lg.me-0")
                                        ]                                                            
                                    )
                                ),
                                m(".table-responsive",
                                    m("table.table table-striped",
                                        [
                                            m("thead",
                                                m("tr.align-middle",
                                                    [
                                                        m("th", { "scope": "col" }, this.getText("LT00000134XX", "Sample Image")),
                                                        m("th", { "scope": "col" }, this.getText("LT00000012XX", "Display Name")),
                                                        m("th", { "scope": "col", "colspan": "2" }, "")
                                                    ])
                                            ),
                                            m("tbody",
                                                listOfDisplays.length == 0 &&
                                                m("tr", { "class": "align-middle" },
                                                    m("td", { "colspan": "4" }, this.getText("EM00000141", "No records found."))
                                                ),
                                                listOfDisplays.map(display =>
                                                    [
                                                        m("tr",
                                                            [
                                                                m("td", m('img', { "src": display.fileContent, "style": "height: 80px;" })),
                                                                m("td", m('div',
                                                                    m('div', display.name),
                                                                    m('.row',
                                                                        m('.col-md-12.mt-3',
                                                                            m('div',
                                                                                m('span', this.getText("EM00000141XX", "Warning Score")),
                                                                                m('.badge.rounded-pill.bg-warning.text-dark.ms-3', display.warningScore.toFixed(2)),
                                                                            )
                                                                        ),
                                                                        m('.col-md-12.mt-3',
                                                                            m('div',
                                                                                m('span', this.getText("EM00000141XX", "Passing Score")),
                                                                                m('.badge.rounded-pill.bg-primary.ms-3', display.passingScore.toFixed(2)),
                                                                            )
                                                                        )
                                                                    )
                                                                    
                                                                )),
                                                                m("td", m("a", { "href": "javascript:;", onclick: () => { showEditDisplayPopup(display.id) } }, m("span", languageModel.getText("LT00000128", "Edit")))),
                                                                m("td", m("a", { "href": "javascript:;", onclick: () => { showDeleteDisplayConfirmation(display.id) } }, m("span", languageModel.getText("LT00000135", "Delete"))))
                                                            ])
                                                    ]),
                                            )
                                        ]
                                    )
                                ),
                                m(paginationComponent,
                                    {
                                        currentPage: inputDataModel.pageIndex,
                                        pageSize: inputDataModel.pageSize,
                                        totalItems: inputDataModel.totalCount,
                                        onPageChanged: onPageChanged,
                                        onPageSizeChanged: onPageSizeChanged
                                    }
                                )
                            )
                        )
                    ),
                    m(Dialog, {
                        isOpen: isPopupAddDisplayOpened,
                        transitionDuration: 200,
                        closeOnOutsideClick: false,
                        onClose: () => { isPopupAddDisplayOpened = false; },
                        title: this.getText("LT00000058XX", "Create New Display"),
                        content: m(CVDisplayAddView, {
                            onPopupClose: () => { isPopupAddDisplayOpened = false },
                            onSaveComplete: onAddDisplayComplete,
                            projectId: selectedProjectId
                        }),
                        "class": "cui-dialog-xxl"
                    }),
                    m(Dialog, {
                        isOpen: isPopupEditDisplayOpened,
                        transitionDuration: 200,
                        closeOnOutsideClick: false,
                        onClose: () => { isPopupEditDisplayOpened = false; },
                        title: this.getText("LT00000128", "Edit"),
                        content: m(CVDisplayEditView, {
                            onPopupClose: () => { isPopupEditDisplayOpened = false },
                            onSaveComplete: onEditDisplayComplete,
                            projectId: selectedProjectId,
                            displayId: selectedDisplayId
                        }),
                        "class": "cui-dialog-xxl"
                    }),
                ),
                this.getBaseViews()
            ]
        }
    }
}
